/** Keyboard rules of dialogs (components/ui.tsx `Modal`, components/ResendConfirm.tsx); pure, tested with node --test. */

/** Where Tab (or Shift+Tab) moves focus among `count` focusable elements from `current` (-1: outside them): it
 * wraps at both ends, so focus never leaves the dialog. */
export function nextFocusIndex(current: number, count: number, backwards: boolean): number {
  if (count <= 0) return -1;
  if (current < 0) return backwards ? count - 1 : 0;
  return backwards ? (current - 1 + count) % count : (current + 1) % count;
}

/** Enter confirms a confirmation dialog unless focus is on another control that handles Enter itself (a button, a
 * link, a text area, a select). */
export function enterConfirms(target: { tagName: string } | null, confirmButton: unknown): boolean {
  if (!target) return true;
  if (target === confirmButton) return false; // the button's own click handles it
  return !["BUTTON", "A", "TEXTAREA", "SELECT"].includes(target.tagName.toUpperCase());
}

export const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
